import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/NotificationMessage/List',
    method: 'post',
    data,
  })
}
export function updateToken(data) {
  return request({
    url: '/NotificationMessage/UpdateToken',
    method: 'post',
    data,
  })
}

export function updateMessage(data) {
  return request({
    url: '/NotificationMessage/UpdateMessage',
    method: 'post',
    data,
  })
}

export function markAllRead(data) {
  return request({
    url: '/NotificationMessage/MarkAllRead',
    method: 'post',
    data,
  })
}
